import { Button } from '@mui/material';

const SubmitButton = ({ isRegister }) => {
  return (
    <Button
      variant="contained"
      type="submit"
      fullWidth
      sx={{
        display: 'flex',
        justifyContent: 'center', 
        alignItems: 'center',
        background: 'linear-gradient(to right, #38c6d9, #ff00ff)', // Gradient background
        color: 'white',
        fontSize: '16px',
        fontWeight: 'bold',
        borderRadius: '50px', 
        padding: '8px 10px', 
        fontFamily: '"Jost", sans-serif',
        textTransform: 'none', // Prevent uppercase text
        transition: '0.3s',
        marginTop: '10px', // Space above the button
        width: '90%', // Keeps some margin on the sides
        maxWidth: '400px', // Limits max width for better UI
        mx: 'auto', // Centers the button horizontally
        '&:hover': {
          background: 'linear-gradient(to right, #2da3b3, #d400d4)', // Darker gradient on hover
        },
      }}
    >
      {isRegister ? 'Register' : 'Sign in'}
    </Button>
  );
};

export default SubmitButton;